module.exports = __webpack_public_path__ + "img/ss-o-2.6e1abe88.png";